import script from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=bf417820&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf417820"]])

export default __exports__